<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-12 d-block d-md-none">
            <router-link
              :to="'/'"
              class="btn-link font-weight-normal text-white"
              title="Voltar para o início"
              ><i class="fas fa-chevron-left mr-1"></i> Voltar</router-link
            >
          </div>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--7">
      <card
        class="col-xl-6 offset-xl-2 col-xl-8 col-lg-12 mb-5"
        shadow
        footerClasses="py-2 text-center"
        bodyClasses="p-1"
        ref="loader_collaborator"
      >
        <div slot="header" class="bg-white border-0">
          <div class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">Usuário</h3>
            </div>
          </div>
        </div>
        <template>
          <div class="row text-center">
            <div class="col-md-4 mt-2">
              <img
                v-if="user.profilePicture"
                :src="user.profilePicture.url"
                width="150"
                height="150"
                class="rounded-circle"
                alt="..."
              />
              <img
                v-else
                src="/img/pages/default_banner_course.jpg"
                width="150"
                height="150"
                class="rounded-circle"
                alt="..."
              />
              <h3 class="mt-3">{{ user.name }}</h3>
            </div>
            <div class="col-md-8">
              <h4 class="mt-lg-3 mt-xl-3 mt-md-3">
                Categorias:
                <span
                  v-for="category in user.collaboratorCategories"
                  :key="category.id"
                  class="font-weight-light"
                  >{{ category.category.title }};
                </span>
              </h4>
              <div>
                <div class="h5 font-weight-300 mb-1">
                  <email-link :emailAddress="user.user.email" />
                </div>
              </div>
              <div>
                <div class="h5 font-weight-300 mb-1">
                  <whatsapp-link :phoneNumber="user.phone" />
                </div>
              </div>
              <h4 class="mt-lg-3 mt-xl-3 mt-md-3">
                {{ user.city }}
              </h4>
              <div class="h5 font-weight-300 mb-1">
                {{ user.short_bio }}
              </div>
            </div>
          </div>
        </template>
      </card>
      <div ref="news_feed" :key="event.id" v-for="(event, index) in news">
        <div class="col-xl-6 offset-xl-2 col-xl-8 col-lg-12 mb-4 card px-2">
          <p class="mb-2 mt-2">
            <a @click="handleViewCollaborator(event)" class="click-name">
              <img
                width="30"
                height="30"
                v-if="event.profile_picture"
                :src="event.profile_picture"
                class="rounded-circle"
                alt="foto de perfil"
              />
              <i v-else class="fas fa-user-circle user-default-logo"></i>
              <span class="ml-2">{{
                event.collaborator_name
                  ? event.collaborator_name
                  : event.company_name
              }}</span>
            </a>
          </p>
          <img
            v-if="event.image_url"
            class="image-feed rounded mx-auto d-block col-12 px-0"
            :src="event.image_url"
            alt="..."
          />
          <quill-editor
            v-model="event.body"
            :options="editorReadOnly"
            disabled="disabled"
          >
          </quill-editor>
          <div class="m-3 d-flex">
            <base-button
              disabled
              class="btn btn-white"
              :title="!event.liked ? 'A empresa não pode curtir' : 'Descurtir'"
            >
              <div v-if="!event.liked" class="">
                <i class="far fa-heart fa-sm"></i>
                {{ event.likes }}
              </div>
              <div v-else class="">
                <i class="fas fa-heart fa-sm"></i>
                {{ event.likes }}
              </div>
            </base-button>
            <base-button
              class="btn btn-white"
              @click="$router.push(`/empresa/social/${event.id}/visualizar`)"
            >
              <i class="far fa-comment fa-sm"></i> {{ event.comments }}
            </base-button>
            <base-button
              v-tooltip="
                news[index].status === 'public'
                  ? 'Oculte uma publicação que pode não estar de acordo.'
                  : 'Deixar publicação visível novamente.'
              "
              class="btn btn-white"
              @click="handleSetStatus(index)"
            >
              <i
                v-if="news[index].status === 'public'"
                class="far fa-eye-slash"
              ></i>
              <i v-else class="far fa-eye"></i>
            </base-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
import api from "@/services/api";
export default {
  name: "call-card",
  components: { quillEditor },
  data() {
    return {
      bgClasses: [
        "warning",
        "info",
        "primary",
        "success",
        "secondary",
        "danger",
        "light",
        "dark"
      ],
      user: {},
      news: [],
      editorReadOnly: {
        placeholder: "...",
        readOnly: true,
        theme: "bubble"
      }
    };
  },
  async mounted() {
    await this.loadUser();
    await this.loadPublications();
  },
  methods: {
    async loadUser() {
      const loader = this.$loading.show({
        container: this.$refs.loader_collaborator,
        loader: "dots",
        width: 90,
        height: 90,
        opacity: 0
      });
      try {
        const { data } = await api.get(
          `/company/collaborators/${this.$route.params.id}`
        );
        if (data) {
          this.user = data;
        }
        loader.hide();
      } catch (e) {
        this.$toasted.error(`Ocorreu um erro ao recuperar o perfil`);
      }
    },
    async loadPublications(errorMsg) {
      const loader = this.$loading.show({
        container: this.$refs.news_feed,
        loader: "dots",
        width: 90,
        height: 90,
        opacity: 0
      });
      try {
        const {
          data: { data, meta }
        } = await api.get(`/company/news/user/${this.$route.params.id}`);
        if (data.length) {
          this.news = data;
          this.meta = meta;
        }
        loader.hide();
      } catch (e) {
        this.$toasted.error(`Ocorreu um erro ao recuperar ${errorMsg}`);
      }
    },
    tasksSubmissions() {
      let submissionCount = 0;
      this.tasks.forEach(task => {
        if (task.submission.length) {
          submissionCount += 1;
        }
      });
      return submissionCount;
    }
  }
};
</script>
<style scoped>
.card-profile-stats > div .heading {
  font-size: 1rem;
}

.user-default-logo {
  font-size: 30px;
  vertical-align: middle;
}
</style>
